<template>
	<v-dialog
		v-model="showDialog"
		max-width="1200px"
		:fullscreen="$vuetify.breakpoint.mdAndDown ? true : false"
		:transition="$vuetify.breakpoint.mdAndDown ? 'scroll-y-reverse-transition' : ''"
	>
		<v-card :tile="$vuetify.breakpoint.mdAndDown">
			<v-toolbar dark color="primary" dense flat>
				<v-toolbar-title style="color: white">見積詳細</v-toolbar-title>
				<v-spacer></v-spacer>
				<v-btn icon dark @click="showDialog = false" color="white">
					<v-icon>mdi-close</v-icon>
				</v-btn>
			</v-toolbar>
			<v-sheet class="pa-2" elevation="0">
				<v-row no-gutters justify="end">
					<v-btn class="mt-4" color="secondary" @click="openMatterDialog">
						<v-icon class="mr-1">mdi-information-outline</v-icon>
						案件情報を確認する
					</v-btn>
					<v-btn
						class="ml-2 mt-4"
						color="secondary"
						@click="$router.push({ name: '', params: { id } })"
					>
						<v-icon class="mr-1">mdi-file-document-outline</v-icon>
						原価計算を確認する
					</v-btn>
					<ConstructionAnswerNewDialog :requirement="requirement"
					@submit-answer="submitAnswer($event)"
					/>
					<!-- TODO v-if 施工法検討依頼なし -->
					<ConstructionRequirementNewDialog
						:id="id"
						@submit-requirement="submitRequirement($event)"
					/>
					<!-- TODO v-else-if 施工法検討依頼ありで回答なし -->
					<!-- <v-btn class="ml-2 mt-4" color="secondary" disabled>
						<v-icon class="mr-1">mdi-file-document-outline</v-icon>
						施工法検討依頼発行済み
					</v-btn> -->

					<!-- TODO v-else 施工法検討依頼ありで回答あり btnを追加-->
				</v-row>

				<v-row no-gutters>
					<v-col cols="12" md="6" class="pr-lg-2">
						<table width="100%" class="mt-4 show-dialog-table">
							<!-- TODO valueをサンプルデータから変更 -->
							<tbody>
								<ShowDetailRecord :columnName="'台帳番号'" :value="''" />
								<ShowDetailRecord :columnName="'見積番号'" :value="''" />
								<ShowDetailRecord :columnName="'製品区分'" :value="''" />
								<ShowDetailRecord :columnName="'依頼者'" :value="''" />
								<ShowDetailRecord :columnName="'受注先'" :value="''" />
								<ShowDetailRecord :columnName="'プラントメーカー'" :value="''" />
								<ShowDetailRecord :columnName="'施工場所'" :value="''" />
								<ShowDetailRecord :columnName="'工事名'" :value="''" />
								<ShowDetailRecord :columnName="'受付日'" :value="''" />
								<ShowDetailRecord :columnName="'提出期限'" :value="''" />
								<ShowDetailRecord :columnName="'提出日'" :value="''" />
								<ShowDetailRecord :columnName="'引合検討'" :value="''" />
								<ShowDetailRecord :columnName="'営業積算'" :value="''" />
								<ShowDetailRecord :columnName="'工事積算'" :value="''" />
								<ShowDetailRecord :columnName="'現地工事工程検討'" :value="''" />
								<ShowDetailRecord :columnName="'担当'" :value="''" />
								<ShowDetailRecord :columnName="'依頼納期 着工予定'" :value="''" />
								<ShowDetailRecord :columnName="'依頼納期 予定工期'" :value="''" />
								<ShowDetailRecord :columnName="'受注確度'" :value="''" />
							</tbody>
						</table>
					</v-col>
					<v-col cols="12" md="6" class="pr-lg-2">
						<table width="100%" class="mt-4 show-dialog-table">
							<!-- TODO valueをサンプルデータから変更 -->
							<tbody>
								<ShowDetailRecord :columnName="'客先工事区分'" :value="''" />
								<ShowDetailRecord :columnName="'工事内容'" :value="''" />
								<ShowDetailRecord :columnName="'品名'" :value="''" />
								<ShowDetailRecord :columnName="'寸法'" :value="''" />
								<ShowDetailRecord :columnName="'数量'" :value="''" />
								<ShowDetailRecord :columnName="'工事名'" :value="''" />
								<ShowDetailRecord :columnName="'客先仕様書'" :value="''" />
								<ShowDetailRecord :columnName="'客先図面'" :value="''" />
								<ShowDetailRecord :columnName="'内容液（濃度）'" :value="''" />
								<ShowDetailRecord :columnName="'温度'" :value="''" />
								<ShowDetailRecord :columnName="'材質指定'" :value="''" />
								<ShowDetailRecord :columnName="'厚み指定'" :value="''" />
								<ShowDetailRecord :columnName="'硬さ指定'" :value="''" />
								<ShowDetailRecord :columnName="'物性規格'" :value="''" />
								<ShowDetailRecord :columnName="'その他'" :value="''" />
								<ShowDetailRecord :columnName="'RL検査 客先指定検査'" :value="''" />
								<ShowDetailRecord :columnName="'RL検査 立会検査'" :value="''" />
								<ShowDetailRecord :columnName="'既設ゴム剥離 剥離（ゴム種類）'" :value="''" />
								<ShowDetailRecord :columnName="'既設ゴム剥離 産廃'" :value="''" />
								<ShowDetailRecord :columnName="'施工環境'" :value="''" />
								<ShowDetailRecord :columnName="'成形場所'" :value="''" />
								<ShowDetailRecord :columnName="'材料保管場所'" :value="''" />
								<ShowDetailRecord :columnName="'電気（100Ｖ.220Ｖ）'" :value="''" />
								<ShowDetailRecord :columnName="'水'" :value="''" />
								<ShowDetailRecord :columnName="'蒸気（飽和）'" :value="''" />
								<ShowDetailRecord :columnName="'エアー'" :value="''" />
								<ShowDetailRecord :columnName="'作業用足場・架払い'" :value="''" />
								<ShowDetailRecord :columnName="'検査用足場・架払い'" :value="''" />
								<ShowDetailRecord :columnName="'下地処理（ブラスト）'" :value="''" />
								<ShowDetailRecord :columnName="'下地処理（電動工具）'" :value="''" />
								<ShowDetailRecord :columnName="'現地発生産廃（廃プラ）'" :value="''" />
								<ShowDetailRecord :columnName="'ブラスト砂産廃'" :value="''" />
								<ShowDetailRecord :columnName="'現地監視人'" :value="''" />
							</tbody>
						</table>
					</v-col>
				</v-row>
			</v-sheet>
		</v-card>
	</v-dialog>
</template>

<script>
import axios from "axios"
import errorHandling from "../../../helper/errorHandling"
import authenticate from "../../../helper/authenticate"
import common from "../../../helper/common"
import rules from "../../../helper/rules"
import ShowDetailRecord from "../../shared/ShowDetailRecord.vue"
import ConstructionRequirementNewDialog from "./ConstructionRequirementNewDialog.vue"
import ConstructionAnswerNewDialog from "./ConstructionAnswerNewDialog.vue"

export default {
	props: {
		dialog: {
			type: Boolean,
			required: false,
			default: false,
		},
		requirement_data: {
			type: null,
			required: false,
			default: null,
		},
		id: {
			type: Number,
			required: false,
			default: null,
		},
		authority_flag: {
			type: Boolean,
			required: false,
			default: false,
		},
	},
	components: {
		ShowDetailRecord,
		ConstructionRequirementNewDialog,
		ConstructionAnswerNewDialog,
	},
	data() {
		return {
			requirement: {
				matter: {
					matter_products: [],
				},
			},
			confirmationDialog: false,
			common,
			rules,
		}
	},
	methods: {
		fetchRequirement(id) {
      // 現状不使用
			const headers = authenticate.setHeader()
			const url = `/erp/v1/constructions/requirements/${id}`
			axios
				.get(url, { headers })
				.then((res) => {
					this.requirement = res.data.requirement
				})
				.catch((err) => {
					errorHandling.errorResponse(err)
				})
		},
		openMatterDialog() {
			// TODO MatterShowDialogを開く
		},
		submitRequirement() {
			// TODO
		},
		submitAnswer(){
			// TODO
		}
	},
	computed: {
		showDialog: {
			get() {
				return this.dialog
			},
			set(newVal) {
				return this.$emit("update:dialog", newVal)
			},
		},
	},
	watch: {
		requirement_data(newVal, oldVal) {
			this.requirement = newVal
		},
		id(newVal, oldVal) {
			if (newVal == oldVal) return
			this.fetchRequirement(newVal)
		},
		deep: true,
	},
}
</script>